import { Component, EventEmitter, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {
  OrganisationService,
} from 'src/app/organisation/organisation.service';
import { forkJoin } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import {
  PgMessagesService,
  MessageLevel,
} from 'src/app/shared/services/pg-messages.service';
import {
  DocumentReference,
  DocumentService,
} from 'src/app/documents/documents.service';
import { PgTitleComponent } from 'src/app/shared/components/title-bar/title-bar.component';
import { saveAs } from 'file-saver';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatIconModule } from '@angular/material/icon';
import { MaterialOrganisationSelectorComponent } from 'src/app/shared/components/material-autocomplete/material-organisationselector.component';
import { MaterialAutoCompleteComponent } from 'src/app/shared/components/material-autocomplete/material-auto-complete.component';
import { MaterialChunkFileUploadComponent } from 'src/app/shared/components/material-file-uploader/material-chunk-file-upload.component';
import { MaterialPdfViewerComponent } from 'src/app/shared/components/material-pdf-viewer/material-pdf-viewer.component';
import { MaterialPgInputComponent } from 'src/app/shared/components/material-pg-input/material-pg-input.component';
import { MaterialPgButtonComponent } from 'src/app/shared/components/material-pg-button/material-pg-button.component';
import { Organisation } from 'src/app/generated/services/organisations/organisation';
import { MaterialOffsetDateTimeComponent } from 'src/app/shared/components/material-offset-date-time/material-offset-date-time.component';
import { Vessel, VesselsService } from '../../vessels.service';
import { FreshwaterDeliveryNote } from 'src/app/generated/services/transportation/reports/freshwater';
import { FreshwaterServiceSpa } from 'src/app/generated/services/transportation/reports/freshwaterSpa';

@Component({
  selector: 'app-fresh-water',
  templateUrl: './fresh-water.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    SharedModule,
    MatIconModule,
    MaterialOrganisationSelectorComponent,
    MaterialAutoCompleteComponent,
    MaterialChunkFileUploadComponent,
    MaterialPdfViewerComponent,
    MaterialPgInputComponent,
    MaterialPgButtonComponent,
    MaterialOffsetDateTimeComponent
  ],
})
export class FreshWaterComponent implements OnInit, PgTitleComponent {
  valid: any;
  title: EventEmitter<string> = new EventEmitter();
  toolbarComponent: any;
  uploadedFileId: string = '';
  vessels: Vessel[] = [];
  fdnNumber: string | null = null;
  timestamp: string | null = null;
  ports: Organisation[] = [];
  freshWaterDeliveryNote = FreshwaterDeliveryNote.create();
  expectedVersion: number = 0;
  selectedPortOrganisation = Organisation.create();
  locationSelected = false;
  selectedSupplierOrganisation = Organisation.create();
  message: string = '';
  supplier: Organisation[] = [];
  quantity: number = 0;
  edit: boolean = false;
  selectedVessel = Vessel.create();
  date: any;
  vesselImo: string | null = null;
  doc?: DocumentReference;

  constructor(
    private _activateRoute: ActivatedRoute,
    private _organisationService: OrganisationService,
    private _documentsService: DocumentService,
    private _router: Router,
    private _pgMessagesService: PgMessagesService,
    private _vesselsService: VesselsService,
    private _freshWaterService: FreshwaterServiceSpa,

  ) { }

  ngOnInit() {
    this.valid = false;
    this.title.emit('Fresh Water Delivery Note');
    this._activateRoute.paramMap.subscribe((p) => {
      this.fdnNumber = p.get('fdnNumber');
      this.timestamp = p.get('date');
      this.vesselImo = p.get('vesselImo');
    });
    forkJoin([
      this._organisationService.getPorts(),
      this._organisationService.getFreshWaterSupplier(),
      this._vesselsService.getVessels(),
    ]).subscribe((results) => {
      this.ports = results[0];
      this.supplier = results[1];
      this.vessels = results[2].filter((v) => v.active);
      this.initFreshWaterDeliveryNote();
    });
  }

  async initFreshWaterDeliveryNote() {
    if (this.fdnNumber && this.timestamp && this.vesselImo) {
      this.edit = true;
      const result = (await this._freshWaterService
        .getOneFreshWaterDeliveryNote({
          vesselImo: this.vesselImo,
          fdnNumber: this.fdnNumber,
          timestamp: this.timestamp}
        ));
      this.freshWaterDeliveryNote = result.data ?? FreshwaterDeliveryNote.create();
      this.expectedVersion = result.version;
      this.selectedVessel = this.vessels.find((v) => v.imo === this.freshWaterDeliveryNote.vesselImo) ?? Vessel.create();
      this.selectedPortOrganisation = this.ports.find(
        (p) => p.name === this.freshWaterDeliveryNote.locationOrganisationId
      ) ?? Organisation.create();
      this.selectedSupplierOrganisation = this.supplier.find(
        (p) => p.name === this.freshWaterDeliveryNote.supplierOrganisationId
      ) ?? Organisation.create();
      this.valid = this.freshWaterDeliveryNote.fileId ? true : false;
      this.uploadedFileId = this.freshWaterDeliveryNote.fileId;
    }
  }

  uploadFDNFile(fdn: DocumentReference) {
    this.freshWaterDeliveryNote.fileId = fdn.id;
  }

  save() {
    this.freshWaterDeliveryNote.vesselImo = this.selectedVessel.imo;
    this.freshWaterDeliveryNote.vesselName = this.selectedVessel!.name!.name;
    this.freshWaterDeliveryNote.supplierOrganisationId = this.selectedSupplierOrganisation.name;
    this.freshWaterDeliveryNote.locationOrganisationId = this.selectedPortOrganisation.name;
    this.freshWaterDeliveryNote.product = 'freshWater';
    if(this.edit) {
      this._freshWaterService
        .updateFreshwaterDeliveryNote({data: this.freshWaterDeliveryNote, expectedVersion: this.expectedVersion})
        .then(
          () => {
            this.message = `${this.freshWaterDeliveryNote.vesselName}`;
            this._pgMessagesService.publishMessage({
              message: this.message,
              topic: 'Submitting Fresh Water Delivery Note successfully',
              level: MessageLevel.Info,
            });
            this._router
              .navigateByUrl('/', { skipLocationChange: true })
              .then(() => {
                this._router
                  .navigate([
                    'vessels/fresh-water',
                    this.freshWaterDeliveryNote.vesselImo,
                    this.freshWaterDeliveryNote.bdnNumber,
                    this.freshWaterDeliveryNote.date?.isoDate,
                  ])
                  .then((e) => console.log(`Result of Navigation is ${e}`));
              });
          },
          () => {
            this.message = 'Error';
            this._pgMessagesService.publishMessage({
              message: this.message,
              topic: 'Fresh Water Delivery Note Insertion Error',
              level: MessageLevel.Error,
            });
          }
        );
    } else {
      this._freshWaterService
        .addFreshwaterDeliveryNote(this.freshWaterDeliveryNote)
        .then(
          () => {
            this.message = `${this.freshWaterDeliveryNote.vesselName}`;
            this._pgMessagesService.publishMessage({
              message: this.message,
              topic: 'Submitting Fresh Water Delivery Note successfully',
              level: MessageLevel.Info,
            });
            this._router
              .navigateByUrl('/', { skipLocationChange: true })
              .then(() => {
                this._router
                  .navigate([
                    'vessels/fresh-water',
                    this.freshWaterDeliveryNote.vesselImo,
                    this.freshWaterDeliveryNote.bdnNumber,
                    this.freshWaterDeliveryNote.date?.isoDate,
                  ])
                  .then((e) => console.log(`Result of Navigation is ${e}`));
              });
          },
          () => {
            this.message = 'Error';
            this._pgMessagesService.publishMessage({
              message: this.message,
              topic: 'Fresh Water Delivery Note Insertion Error',
              level: MessageLevel.Error,
            });
          }
        );
    }

  }

  remove() {
    if (
      confirm('Are you sure you want to delete this Fresh Water Delivery Note?')
    ) {
      this.freshWaterDeliveryNote.isDeleted = true;
      this._freshWaterService
        .updateFreshwaterDeliveryNote({data: this.freshWaterDeliveryNote, expectedVersion: this.expectedVersion})
        .then(() => {
          this._router.navigate(['/vessels/fresh-water']);
          this.message = 'Remove Fresh Water Delivery Note';
          this._pgMessagesService.publishMessage({
            message: this.message,
            topic: 'Deleted',
            level: MessageLevel.Info,
          });
        });
    }
  }

  downloadFile(fileId: string) {
    this._documentsService.download(fileId).subscribe(
      (b) => {
        saveAs(b.body, `${this.selectedSupplierOrganisation.name}.pdf`);
      },
      () => {
        this._pgMessagesService.publishMessage({
          message: 'Could not download this file.',
          level: MessageLevel.Error,
          topic: 'Fresh Water document',
        });
      }
    );
  }

  vesselFormatter(vessel: Vessel) {
    if (vessel){
      return vessel.name?.name;
    }
    return '';
  }
}
